import { Fragment, useEffect, useRef, useState } from 'react';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { useCellEditing } from '../../../shared/hooks/CellEditing';
import { ProductService } from '../../danh-muc/hang-hoa-dich-vu/ProductService';
import { FormatDisplay } from '../../../shared/format';
import { AmountToWord } from '../../../service/AmountToWord';
import { InputNumber } from 'primereact/inputnumber';
import { OrderService } from '../OrderService';
import { AutoComplete } from 'primereact/autocomplete';
import { PriceService } from '../../danh-muc/bang-gia-vang/PriceService';
import { TenantClientService } from '../../danh-muc/khach-hang/TenantClientService';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';
import { Dropdown } from 'primereact/dropdown';
import { useDialogCrup } from '../../../shared/hooks/DialogCrup';
import { UnitService } from '../../danh-muc/don-vi-tinh/UnitService';
import { TaxService } from '../../danh-muc/thue-suat/TaxService';
import { PartnerService } from '../../danh-muc/doi-tac/PartnerService';
import { GroupProductService } from '../../danh-muc/nhom-san-pham/GroupProductService';
import { PaymentTypeService } from '../../danh-muc/ht-thanh-toan/PaymentTypeService';
import { ToastService } from '../../../AppToast';
import { CurrencyService } from '../../danh-muc/tien-te/CurrencyService';
import { AppStorage } from '../../../service/UserStorage';
import { TenantSettingService } from '../../he-thong/tham-so-he-thong/TenantSettingService';

const generateId = () => `added-item-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}`

const calculateAmount = (quantity, weight, price, wage) => {
  if (weight) {
    return quantity * weight * price + wage
  }
  return quantity * price + wage

}

export const DialogKaraokeNhaHang = ({ display, onHide, selectedInvoice }) => {
  const [dataSource, setDataSource] = useState([{ id: generateId(), typeOrder: 1, ordinalNumber: 1, productName: "", productId: "", quantity: 1, unitCode: "", weight: null, weightOther: null, price: null, wage: null, amount: 0, serviceFeeRate: null, serviceFeeAmount: null, ortherTax: null, ratioOrtherTax: null,vatAmount: 0, amountWithoutVAT: 0, taxId: '', totalAmount: 0 }])
  const [products, setProducts] = useState([])
  const [customers, setCustomers] = useState([])
  const [suggestions, setSuggestions] = useState([])
  const [formData, setFormData] = useState({
    buyerTaxCode: null,
    buyerCode: null,
    buyerLegalName: null,
    buyerAddress: null,
    buyerDisplayName: null,
    buyerEmail: null,
    buyerTel: null,
    buyerIdentityCard: null,
    buyerBankAccount: null,
    buyerBankName: null,
    amount: null,
    totalExciseTaxAmount: null,
    totalVATDeduction: null,
    totalAmount: null,
    totalAmountToWord: null,
    orderDate: new Date(),
    orderNumber: null,
    paymenType: null,
    ratioOrtherTax: 0,
    ortherTax: 0,
    totalAmountWithoutVAT: 0,
    vatAmount: 0,
    serviceCharge: 0
  },)
  const [units, setUnits] = useState([]);
  const [partners, setPartners] = useState([]);
  const [taxs, setTaxs] = useState([]);
  const [groupProducts, setGroupProduct] = useState([]);
  const [paymentType, setPaymentType] = useState([]);
  const [addButtonRowData, setAddButtonRowData] = useState(null);
  const [addButtonColumn, setAddButtonColumn] = useState(null);
  const [currency, setCurrency] = useState([])
  const [displayPreview, setDisplayPreview] = useState(false)
  const [tenantSetting, setTenantSetting] = useState([])
  const preview = useRef<HTMLIFrameElement>(null)

  const handleFormChange = (key, value) => {
    if (key === "buyerTaxCode" || key === "buyerIdentityCard" || key === "buyerCode") {
      // if (value.code === "taxCode") {
      const code = value.split("-")[0];
      const find = customers.find(item => {
        return item.code === code
      })
      if (find) {
        return setFormData({
          ...formData,
          buyerTaxCode: find?.taxCode,
          buyerIdentityCard: find?.identificationCard,
          buyerCode: find?.code,
          buyerLegalName: find?.name,
          buyerAddress: find?.address,
          buyerDisplayName: find?.personContact,
          buyerEmail: find?.email,
          buyerTel: find?.mobile,
          buyerBankAccount: find?.bankAccount,
          buyerBankName: find?.bankName
        })
      }
      return setFormData({ ...formData, [`${key}`]: value })
    } else {
      setFormData({ ...formData, [`${key}`]: value })
    }
  }

  const addItem = () => {
    setDataSource([...dataSource, { id: generateId(), typeOrder: 1, ordinalNumber: dataSource.length + 1, productName: "", productId: "", quantity: 1, unitCode: "", weight: null, weightOther: null, price: null, wage: null, amount: 0, serviceFeeRate: null, serviceFeeAmount: null, ortherTax: null, ratioOrtherTax: null,vatAmount: 0, amountWithoutVAT: 0, taxId: '', totalAmount: 0 }])
  }

  const insertItem = () => {
    if (selectedItem) {
      const _items = [];
      const dataSourceClone = [...dataSource]
      dataSourceClone?.forEach(detail => {
        if (detail.id === selectedItem.id) {
          _items.push(Object.assign({ id: generateId(), ordinalNumber: dataSource.length + 1, productName: "", productId: "", quantity: 1, unitCode: "", weight: null, weightOther: null, price: null, wage: null, amountWithoutVAT: 0 }));
          _items.push(detail);
        } else {
          _items.push(detail);
        }
      });
      setDataSource(_items)
    }
  }

  const copyItem = () => {
    if (selectedItem) {
      const _items = [...dataSource];
      const clone = Object.assign({}, selectedItem);
      _items.push(Object.assign(clone, { id: generateId(), ordinalNumber: dataSource.length + 1, }));
      setDataSource(_items)

    }
  }

  const addOrder = () => {
    // Validate that all items in dataSource have a taxId defined
    if (dataSource.some(item => !item.taxId)) {
      return ToastService.error("Vui lòng chọn thuế suất cho tất cả các sản phẩm");
    }

    if (selectedInvoice) {
      if (selectedInvoice?.id) {
        return OrderService.update(
          selectedInvoice.id,
          {
            ...formData,
            orderDate: moment(formData.orderDate).toISOString(),
            orderDetails: dataSource.map((obj, index) => {
              // Tạo một bản sao của đối tượng và loại bỏ trường 'id'
              const ratioTax = taxs.find(item => item.id === obj.taxId);

              let newObj = {
                ...obj,
                orders: index + 1,
                ordinalNumber: obj.ordinalNumber ? obj.ordinalNumber.toString() : obj.ordinalNumber,
                weightOther: +obj.weightOther,
                totalWeight: +obj.weight + +obj.weightOther
              };
              delete newObj.id;
              return newObj;
            })
          }
        ).then(() => onHide());
      }
      else {
        return OrderService.create({
          ...formData,
          orderDate: moment(formData.orderDate).toISOString(),
          orderDetails: dataSource.map((obj, index) => {
            // Tạo một bản sao của đối tượng và loại bỏ trường 'age'
            let newObj = {
              ...obj,
              orders: index + 1,
              ordinalNumber: obj.ordinalNumber ? obj.ordinalNumber.toString() : obj.ordinalNumber,
              weightOther: +obj.weightOther,
              totalWeight: +obj.weight + +obj.weightOther,
              weight: obj.weight ? obj.weight : null,
              wage: obj.wage ? obj.wage : null
            };
            delete newObj.id;
            return newObj;
          })
        }).then(() => onHide())
      }
    }
    return OrderService.create({
      ...formData,
      orderDetails: dataSource.map((obj, index) => {
        // Tạo một bản sao của đối tượng và loại bỏ trường 'age'
        let newObj = {
          ...obj,
          orders: index + 1,
          ordinalNumber: obj.ordinalNumber ? obj.ordinalNumber.toString() : obj.ordinalNumber,
          weightOther: +obj.weightOther,
          totalWeight: +obj.weight + +obj.weightOther,
          weight: obj.weight ? obj.weight : null,
          wage: obj.wage ? obj.wage : null
        };
        delete newObj.id;
        return newObj;
      })
    }).then(() => onHide())
  }

  const printOrder = () => {
    setDisplayPreview(true)
    return OrderService.printViewOrder({
      ...formData,
      orderDate: moment(formData.orderDate).toISOString(),
      orderDetails: dataSource.map((obj, index) => {
        // Tạo một bản sao của đối tượng và loại bỏ trường 'age'
        let newObj = {
          ...obj,
          orders: index + 1,
          ordinalNumber: obj.ordinalNumber ? obj.ordinalNumber.toString() : obj.ordinalNumber,
          weightOther: +obj.weightOther,
          totalWeight: +obj.weight + +obj.weightOther,
          weight: obj.weight ? obj.weight : null,
          wage: obj.wage ? obj.wage : null
        };
        delete newObj.id;
        // delete newObj.ordinalNumber;
        return newObj;
      })
    }).then((data) => {
      if (preview.current && preview.current.contentWindow) {
        preview.current.contentWindow.document.open();
        preview.current.contentWindow.document.write(`${data.pagehmtl[0].trim()}`);
      }
    })
  }

  const footer = (
    <div className="flex justify-content-center gap-4">
      <Button label="Đóng" className="p-button-outlined p-button-secondary p-button-sm" onClick={onHide} />
      <Button label="Xem in" className="p-button-outlined p-button-secondary p-button-sm" onClick={printOrder} />
      <Button label="Lưu" className="p-button-outlined p-button-sm" onClick={addOrder} />
      {/* <Button label="Lưu và Xem in" className="p-button-outlined p-button-sm" />
      <Button label="Lưu và Ký" className="p-button-outlined p-button-sm" /> */}
      {/* {['create', 'clone'].includes(display) && <Button label="Lưu và Tạo tiếp" onClick={() => submit('continue')} loading={submitting} className="p-button-outlined p-button-sm" />} */}
    </div>
  );

  const onCellChange = async (rowData, column, newValue) => {
    let ratioTax;
    if (column.field === "taxId") {
      ratioTax = taxs.find(item => item.id === newValue);
    }
    let priceGold;
    if (newValue?.id) {
      priceGold = await PriceService.getList({ groupId: newValue.groupId })
    }

    const findIndex = dataSource.findIndex(function (element) {
      return element.id === rowData.id;
    })
    if (findIndex !== -1) {
      // Sử dụng map để sửa đổi phần tử tại vị trí đã tìm thấy
      let newArr = dataSource.map(function (element, index) {
        if (index === findIndex) {

          if (newValue?.id) {
            let price = priceGold?.items[0]?.outPrice ? priceGold?.items[0]?.outPrice : newValue.price
            const amount = calculateAmount(rowData.quantity, newValue.weight, newValue.price, newValue.wage)
            const serviceFeeAmount = amount * (rowData.serviceFeeRate ?? 0) / 100
            const ortherTax = (amount + serviceFeeAmount) * (rowData.ratioOrtherTax ?? 0) / 100
            const amountWithoutVAT = amount + ortherTax + serviceFeeAmount
            const vatAmount = amountWithoutVAT * (newValue?.ratioTax ? newValue?.ratioTax : 0) / 100
            return {
              ...rowData,
              priceGold: priceGold,
              wage: newValue.wage,
              code: newValue.code,
              productId: newValue.id,
              taxId: newValue.taxId,
              ratioTax: newValue.ratioTax,
              productCode: newValue.code,
              unitId: newValue.unitId,
              unitName: newValue.unit,
              unitCode: newValue.unitCode,
              price: price,
              productName: newValue.name,
              groupName: newValue.groupName,
              weight: newValue.weight,
              weightOther: newValue.weightOther,
              amountWithoutVAT: Math.round(amountWithoutVAT),
              amount: amount,
              serviceFeeAmount: Math.round(serviceFeeAmount),
              ortherTax: Math.round(ortherTax),
              vatAmount: Math.round(vatAmount),
              totalAmount: Math.round(+amountWithoutVAT + vatAmount) 
            }
          } else {
            if (column.field === "typeOrder") {
              return {
                ...rowData, [`${column.field}`]: newValue,
                price: newValue ? rowData.priceGold?.items[0]?.outPrice : rowData.priceGold?.items[0]?.inPrice

              }; // Thay thế phần tử tại vị trí tìm thấy

            }
            if (column.field === "quantity") {
              const ratioTax = taxs.find(item => item.id === rowData?.taxId);
              const amount = calculateAmount(newValue, rowData.weight, rowData.price, rowData.wage)
              const serviceFeeAmount = amount * (rowData.serviceFeeRate ?? 0) / 100
              const ortherTax = (amount + serviceFeeAmount) * (rowData.ratioOrtherTax ?? 0) / 100
              const amountWithoutVAT = amount + ortherTax + serviceFeeAmount
              const vatAmount = amountWithoutVAT * (ratioTax?.ratio ? ratioTax?.ratio : 0) / 100

              return {
                ...rowData, [`${column.field}`]: newValue,
                amount,
                amountWithoutVAT: Math.round(amountWithoutVAT),
                vatAmount: Math.round(vatAmount),
                totalAmount: Math.round(amountWithoutVAT + vatAmount),
                ortherTax: Math.round(ortherTax),
                serviceFeeAmount: Math.round(serviceFeeAmount)
              }; // Thay thế phần tử tại vị trí tìm thấy

            }
            if (column.field === "wage") {
              return {
                ...rowData, [`${column.field}`]: newValue,
                // amountWithoutVAT: +rowData.quantity * (+rowData.price + +newValue)
                amountWithoutVAT: Math.round(calculateAmount(rowData.quantity, rowData.weight, rowData.price, newValue))
              }; // Thay thế phần tử tại vị trí tìm thấy
            }
            if (column.field === "price") {
              const ratioTax = taxs.find(item => item.id === rowData?.taxId);
              const amount = calculateAmount(rowData.quantity, rowData.weight, newValue, rowData.wage)
              const serviceFeeAmount = amount * (rowData.serviceFeeRate ?? 0) / 100
              const ortherTax = (amount + serviceFeeAmount) * (rowData.ratioOrtherTax ?? 0) / 100
              const amountWithoutVAT = amount + ortherTax + serviceFeeAmount
              const vatAmount = amountWithoutVAT * (ratioTax?.ratio ? ratioTax?.ratio : 0) / 100

              return {
                ...rowData, [`${column.field}`]: newValue,
                amount,
                amountWithoutVAT: Math.round(amountWithoutVAT),
                vatAmount: Math.round(vatAmount),
                totalAmount: Math.round(amountWithoutVAT + vatAmount),
                ortherTax: Math.round(ortherTax),
                serviceFeeAmount: Math.round(serviceFeeAmount)
              }; // Thay thế phần tử tại vị trí tìm thấy
            }
            if (column.field === "weight") {
              const amount = calculateAmount(rowData.quantity, newValue, rowData.price, rowData.wage)
              const serviceFeeAmount = amount * (rowData.serviceFeeRate ?? 0) / 100
              const ortherTax = (amount + serviceFeeAmount) * (rowData.ratioOrtherTax ?? 0) / 100
              const amountWithoutVAT = amount + ortherTax + serviceFeeAmount
              const vatAmount = amountWithoutVAT * (rowData?.ratioTax ? rowData?.ratioTax : 0) / 100
              return {
                ...rowData, [`${column.field}`]: newValue,
                amount,
                amountWithoutVAT: Math.round(amountWithoutVAT),
                vatAmount: Math.round(vatAmount),
                totalAmount: Math.round(amountWithoutVAT + vatAmount),
                ortherTax: Math.round(ortherTax),
                serviceFeeAmount: Math.round(serviceFeeAmount)
              }; 

            }
            if (column.field === "taxId") {
              const amountWithoutVAT = rowData.amountWithoutVAT
              const vatAmount = amountWithoutVAT * (ratioTax?.taxValue ? ratioTax?.taxValue : 0) / 100
              return {
                ...rowData, [`${column.field}`]: newValue,
                vatAmount: Math.round(vatAmount),
                totalAmount: Math.round(+ amountWithoutVAT + vatAmount),
              }
            }
            if (column.field === "ratioOrtherTax") {
              const ratioTax = taxs.find(item => item.id === rowData?.taxId);
              const amount = rowData.amount
              const serviceFeeAmount = amount * (rowData.serviceFeeRate ?? 0) / 100
              const ortherTax = (amount + serviceFeeAmount) * (newValue || 0) / 100
              const amountWithoutVAT = amount + ortherTax + serviceFeeAmount
              const vatAmount = amountWithoutVAT * (ratioTax?.ratio ? ratioTax?.ratio : 0) / 100

              return {
                ...rowData, [`${column.field}`]: newValue,
                amountWithoutVAT: Math.round(amountWithoutVAT),
                serviceFeeAmount: Math.round(serviceFeeAmount),
                ortherTax: Math.round(ortherTax),
                vatAmount: Math.round(vatAmount),
                totalAmount: Math.round(amountWithoutVAT + vatAmount),
              }
            }

            if (column.field === "ortherTax") {
              const ratioTax = taxs.find(item => item.id === rowData?.taxId);
              const amount = rowData.amount
              const ortherTax = newValue
              const amountWithoutVAT = amount + ortherTax
              const vatAmount = amountWithoutVAT * (ratioTax?.ratio ? ratioTax?.ratio : 0) / 100

              return {
                ...rowData, [`${column.field}`]: newValue,
                amountWithoutVAT: Math.round(amountWithoutVAT),
                ortherTax: Math.round(ortherTax),
                vatAmount: Math.round(vatAmount),
                totalAmount: Math.round(amountWithoutVAT + vatAmount),
              }
            }

            if (column.field === "serviceFeeRate") {
              const ratioTax = taxs.find(item => item.id === rowData?.taxId);
              const amount = rowData.amount
              const serviceFeeAmount = amount * (newValue ?? 0) / 100
              const ortherTax = (amount + serviceFeeAmount) * (rowData.ratioOrtherTax || 0) / 100
              const amountWithoutVAT = amount + ortherTax + serviceFeeAmount
              const vatAmount = amountWithoutVAT * (ratioTax?.ratio ? ratioTax?.ratio : 0) / 100

              return {
                ...rowData, [`${column.field}`]: newValue,
                amountWithoutVAT: Math.round(amountWithoutVAT),
                serviceFeeAmount: Math.round(serviceFeeAmount),
                ortherTax: Math.round(ortherTax),
                vatAmount: Math.round(vatAmount),
                totalAmount: Math.round(amountWithoutVAT + vatAmount),
              }
            }

            if (column.field === "serviceFeeAmount") {
              const ratioTax = taxs.find(item => item.id === rowData?.taxId);
              const amount = rowData.amount
              const serviceFeeAmount = newValue
              const ortherTax = rowData.ortherTax
              const amountWithoutVAT = amount + ortherTax + serviceFeeAmount
              const vatAmount = amountWithoutVAT * (ratioTax?.ratio ? ratioTax?.ratio : 0) / 100

              return {
                ...rowData, [`${column.field}`]: newValue,
                amountWithoutVAT: Math.round(amountWithoutVAT),
                serviceFeeAmount: Math.round(serviceFeeAmount),
                ortherTax: Math.round(ortherTax),
                vatAmount: Math.round(vatAmount),
                totalAmount: Math.round(amountWithoutVAT + vatAmount),
              }
            }
            return {
              ...rowData, [`${column.field}`]: newValue,
            }
          }
        } else {
          return element; // Giữ nguyên các phần tử khác
        }
      });

      setDataSource(newArr)
    } else {
      console.log("Không tìm thấy phần tử trong mảng.");
    }
  }

  const { render: renderDialogCrupProduct, create: createProduct } = useDialogCrup({
    header: 'Hàng hóa, dịch vụ',
    dataKey: 'id',
    width: '60rem',
    fields: [
      { field: 'code', header: 'Mã hàng hóa', required: true, uppercase: true, InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'name', header: 'Tên hàng hóa', required: true, InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'price', header: 'Đơn giá', type: 'InputNumber', InputNumberProps: { min: 0, maxFractionDigits: 6 }, className: 'md:col-6' },
      { field: 'unitId', header: 'Đơn vị tính', type: 'Dropdown', DropdownProps: { options: units, filter: true }, className: 'md:col-6' },
      { field: 'taxId', header: 'Thuế suất', required: JSON.parse(AppStorage.get('tenantInfo'))?.companyType === '03', type: 'Dropdown', DropdownProps: { options: taxs, filter: true }, className: 'md:col-6' },
      { field: 'partnerId', header: 'Nhà cung cấp', type: 'Dropdown', DropdownProps: { options: partners, filter: true }, className: 'md:col-6' },
    ],
    createItem: (item) => {
      return ProductService.create(item);
    },
    refreshLazyData: (data) => {
      if (data) {
        onCellChange(addButtonRowData, addButtonColumn, data);
      }
    }
  });

  const { render: renderDataTable, selectedItem, setSelectedItem } = useCellEditing({
    dataKey: 'id',
    columns: [
      {
        field: 'isShowOrder',
        header: '',
        dataType: 'checkbox',
        editable: true,
        style: { width: "50px" },
        rowReorder: true
      },
      {
        field: "ordinalNumber",
        header: "STT",
        editable: true,
        style: { width: "50px" },
        className: "text-center",
      },
      {
        field: "productCode",
        header: "Mã hàng hóa",
        editable: true,
        className: "text-center",
        dataType: 'autocomplete',
        style: { width: "100px" },

        inputProps: {
          field: 'productCode',
          suggestions: products,
          completeMethod: (event) => {
            ProductService.getList({ code: event.query }).then(({ items }) => {
              setProducts(items);
            });
          }, itemTemplate: (item) => {
            return `${item.code} - ${item.name}`;
          }
        }, addButton: true,
        onAddButtonClick: (rowData, column) => {
          setAddButtonRowData(rowData);
          setAddButtonColumn(column);
          createProduct();
        }

      },
      {
        field: "productName",
        header: "Tên hàng hóa, dịch vụ",
        editable: true,
        style: { width: "250px" },
        dataType: 'autocomplete',
        className: "text-center",
        inputProps: {
          field: 'name',
          suggestions: products,
          completeMethod: (event) => {
            ProductService.getList({ name: event.query }).then(({ items }) => {
              setProducts(items);
            });
          }, itemTemplate: (item) => {
            return `${item.code} - ${item.name}`;
          }
        }, addButton: true,
        onAddButtonClick: (rowData, column) => {
          setAddButtonRowData(rowData);
          setAddButtonColumn(column);
          createProduct();
        }

      },
      {
        field: "unitName",
        header: "Đơn vị tính",
        editable: true,
        className: "text-center",
        style: { width: "100px" },

      },
      {
        field: "quantity",
        header: "Số Lượng",
        dataType: 'number',
        editable: true,
        style: { width: "100px" },
        className: "text-center",
        inputProps: {
          // minFractionDigits: 2,
          maxFractionDigits: currency[0]?.formatQuantity ? currency[0]?.formatQuantity : 6
        },
      },
      {
        field: "price",
        header: "Đơn giá",
        editable: true,
        dataType: "number",
        style: { width: "150px" },

        inputProps: {
          // minFractionDigits: 2,
          maxFractionDigits: currency[0]?.formatPrice ? currency[0]?.formatPrice : 6
        },
      },
      {
        field: "amount",
        header: "Cộng tiền hàng",
        editable: false,
        dataType: "number",
        style: { width: "150px" },
        inputProps: {
          maxFractionDigits: currency[0]?.formatPrice ? currency[0]?.formatPrice : 6
        },
      },
      {
        field: "serviceFeeRate",
        header: "Tỉ lệ phí phục vụ (%)",
        editable: true,
        dataType: "number",
        style: { width: "150px" },
        invisible: !tenantSetting.some(item => item.key === "SU_DUNG_THUE_KHAC" && item.value === "C"),
        inputProps: {
          maxFractionDigits: currency[0]?.formatPrice ? currency[0]?.formatPrice : 6,
          min: 0,
          max: 100
        },
      },
      {
        field: "serviceFeeAmount",
        header: "Tiền phí phục vụ",
        editable: true,
        dataType: "number",
        style: { width: "150px" },
        invisible: !tenantSetting.some(item => item.key === "SU_DUNG_THUE_KHAC" && item.value === "C"),
        inputProps: {
          maxFractionDigits: currency[0]?.formatPrice ? currency[0]?.formatPrice : 6
        },
      },
      {
        field: "ratioOrtherTax",
        header: "Tỉ lệ thuế khác (%)",
        editable: true,
        dataType: "number",
        style: { width: "150px" },
        invisible: !tenantSetting.some(item => item.key === "SU_DUNG_THUE_KHAC" && item.value === "C"),
        inputProps: {
          maxFractionDigits: currency[0]?.formatPrice ? currency[0]?.formatPrice : 6,
          min: 0,
          max: 100
        },
      },
      {
        field: "ortherTax",
        header: "Tiền thuế khác",
        editable: true,
        dataType: "number",
        style: { width: "150px" },
        invisible: !tenantSetting.some(item => item.key === "SU_DUNG_THUE_KHAC" && item.value === "C"),
        inputProps: {
          maxFractionDigits: currency[0]?.formatPrice ? currency[0]?.formatPrice : 6
        },
      },
      {
        field: "amountWithoutVAT",
        header: "Tiền trước thuế",
        dataType: "number",
        style: { width: "200px" },

        inputProps: {
          // minFractionDigits: 2,
          maxFractionDigits: currency[0]?.formatTotal ? currency[0]?.formatTotal : 6
        },
      },
      {
        field: "taxId",
        header: "Thuế suất",
        editable: true,
        className: "text-center",
        dataType: 'dropdown',
        style: { width: "110px" },
        inputProps: {
          options: taxs,
        }
      },
      {
        field: "vatAmount",
        header: "Tiền thuế GTGT",
        dataType: "number",
        style: { width: "200px" },
        inputProps: {
          maxFractionDigits: currency[0]?.formatTotal ? currency[0]?.formatTotal : 6
        },
      },
      {
        field: "totalAmount",
        header: "Thành tiền",
        dataType: "number",
        style: { width: "200px" },

        inputProps: {
          // minFractionDigits: 2,
          maxFractionDigits: currency[0]?.formatTotal ? currency[0]?.formatTotal : 6
        },
      },
    ],
    items: dataSource,
    onCellChange,
    onRowReorder: event => {
      // refreshItems(event.value);
      // setInvoiceDetail(event.value);
    }
  });

  const deleteItem = () => {
    if (selectedItem) {
      const items = dataSource.filter((f) => f.id !== selectedItem.id);
      setDataSource(items)
      // refreshItems(_items);
      setSelectedItem(null);
    }
  }

  const searchCustomers = (key, event) => {
    TenantClientService.getList({ [`${key}`]: event.query, MaxResultCount: 1000 }).then(({ items }) => {
      setCustomers(items)
      setSuggestions(items.map(item => [item.code, item.identificationCard, item.taxCode, item.personContact, item.name, item.address].filter(Boolean).join('-')))
    });
  }

  const handleSearchTaxCode = (type) => {

    switch (type) {
      case "createTenant":
        TenantClientService.searchTaxCode(getValue().taxCode).then((result) => {
          if (result?.error) {
            return ToastService.error(result?.error)
          }
          return setValue(result);
        })
        break;
      case "createOrder":
        TenantClientService.searchTaxCode(formData.buyerTaxCode).then((result) => {
          if (result?.error) {
            return ToastService.error(result?.error)
          }
          return setFormData({
            ...formData,
            buyerTaxCode: result.taxCode || '',
            buyerCode: result.taxCode || '',
            buyerLegalName: result.name || '',
            buyerDisplayName: result.personContact || '',
            buyerAddress: result.address || ''
          });
        })
        break;
    }
  }

  const handleSearchIdentity = (type) => {
    switch (type) {
      case "createTenant":
        TenantClientService.searchIdentityCar(getValue().identificationCard).then((result) => {
          if (result?.error) {
            return ToastService.error(result?.error)
          }
          return setValue({
            ...getValue(),
            personContact: result.ho_ten || '',
          });
        })
        break;
      case "createOrder":
        TenantClientService.searchIdentityCar(formData.buyerIdentityCard).then((result) => {
          if (result?.error) {
            return ToastService.error(result?.error)
          }
          return setFormData({ ...formData, buyerDisplayName: result.ho_ten })
        })
        break;
    }
  }

  const { render: renderDialogTenantClient, create, update, clone, getValue, setValue } = useDialogCrup({
    header: "Khách hàng",
    // dataKey,
    width: '60rem',
    fields: [
      { field: 'code', header: 'Mã khách hàng', required: true, uppercase: true, InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'identificationCard', header: 'CCCD', InputTextProps: { maxLength: 12 }, className: 'md:col-5' },
      {
        type: 'custom', className: 'md:col-1', body: (
          <div className="mt-4">
            <Button icon="pi pi-search" className="p-button-rounded p-button-outlined" onClick={() => handleSearchIdentity("createTenant")} />
          </div>
        )
      },
      { field: 'personContact', header: 'Người mua hàng', InputTextProps: { maxLength: 100 }, className: 'md:col-6' },
      { field: 'taxCode', header: 'Mã số thuế', InputTextProps: { maxLength: 14, validator: 'taxCode' }, className: 'md:col-5' },
      {
        type: 'custom', className: 'md:col-1', body: (
          <div className="mt-4">
            <Button icon="pi pi-search" className="p-button-rounded p-button-outlined" onClick={() => handleSearchTaxCode("createTenant")} />
          </div>
        )
      },
      { field: 'name', header: 'Tên đơn vị', InputTextProps: { maxLength: 400 }, className: 'md:col-12' },
      { field: 'address', header: 'Địa chỉ', InputTextProps: { maxLength: 400 }, className: 'md:col-12' },
      { field: 'email', header: 'Email, Email găn cách bởi dấu , hoặc ; ', InputTextProps: { maxLength: 250 }, className: 'md:col-6' },
      { field: 'mobile', header: 'Điện thoại', InputTextProps: { maxLength: 20 }, className: 'md:col-6' },
      { field: 'bankAccount', header: 'Số tài khoản', InputTextProps: { maxLength: 30 }, className: 'md:col-5' },
      { field: 'bankName', header: 'Tên ngân hàng', InputTextProps: { maxLength: 400 }, className: 'md:col-7' }
    ],
    createItem: (item) => {
      return TenantClientService.create(item);
    },
  });

  useEffect(() => {
    if (display && !selectedInvoice) {
      setFormData({
        buyerTaxCode: null,
        buyerCode: null,
        buyerLegalName: null,
        buyerAddress: null,
        buyerDisplayName: null,
        buyerEmail: null,
        buyerTel: null,
        buyerIdentityCard: null,
        buyerBankAccount: null,
        buyerBankName: null,
        amount: null,
        totalExciseTaxAmount: null,
        totalVATDeduction: null,
        totalAmount: null,
        totalAmountToWord: null,
        orderDate: new Date(),
        orderNumber: null,
        paymenType: paymentType[0]?.value,
        ratioOrtherTax: 0,
        ortherTax: 0,
        totalAmountWithoutVAT: 0,
        vatAmount: 0,
        serviceCharge: 0
      })
      setDataSource([{ id: generateId(), typeOrder: 1, ordinalNumber: 1, productName: "", productId: "", quantity: 1, unitCode: "", weight: null, weightOther: null, price: null, wage: null, amount: 0, serviceFeeRate: null, serviceFeeAmount: null, ortherTax: null, ratioOrtherTax: null,vatAmount: 0, amountWithoutVAT: 0, taxId: '', totalAmount: 0 }])
    }
    if (display && selectedInvoice && selectedInvoice.length !== 0) {
      if (selectedInvoice?.id) {
        OrderService.get(selectedInvoice?.id).then(result => {
          setDataSource(result.orderDetails.map(item => ({ ...item, code: item.productCode })))
        })
      } else {
        setFormData({
          ...selectedInvoice,
          orderDate: new Date(selectedInvoice.orderDate),

        })
        setDataSource(selectedInvoice.orderDetails.map(item => ({ ...item, code: item.productCode })))
      }
    }
  }, [JSON.stringify(selectedInvoice), display])


  useEffect(() => {
    const totalOtherTax = dataSource.reduce((total, item) => {
      return total + (item.ortherTax ? item.ortherTax : 0);
    }, 0);
    
    const totalAmount = dataSource.reduce((total, item) => {
      return total + item.amount;
    }, 0);

    const totalServiceFeeAmount = dataSource.reduce((total, item) => {
      return total + (item.serviceFeeAmount ? item.serviceFeeAmount : 0);
    }, 0);

    const totalAmountWithoutVAT = dataSource.reduce((total, item) => {
      return total + item.amountWithoutVAT;
    }, 0);

    const totalVatAmount = dataSource.reduce((total, item) => {
      return total + item.vatAmount;
    }, 0);

    const total = dataSource.reduce((total, item) => {
      return total + item.totalAmount;
    }, 0);

    setFormData({
      ...formData,
      amount: Math.round(totalAmount),
      ortherTax: Math.round(totalOtherTax),
      serviceCharge: Math.round(totalServiceFeeAmount),
      vatAmount: Math.round(totalVatAmount),
      totalAmountWithoutVAT: Math.round(totalAmountWithoutVAT),
      totalAmount: Math.round(total),
      totalAmountToWord: AmountToWord.DocTienBangChu(total.toString(), "VND", {
        readCurrency: "đồng",
        readDecimal: null
      })
    });

  }, [JSON.stringify(dataSource)])

  useEffect(() => {
    UnitService.getList({
      skipCount: 0,
      maxResultCount: 1000,
    }).then(({ items }) => {
      const _units = [];
      items.forEach(item => {
        _units.push({ value: item.id, label: item.name });
      });
      setUnits(_units);
    });
    TaxService.getList({}).then(({ items }) => {
      const _taxs = [];
      items.forEach((item) => {
        _taxs.push({ value: item.id, label: item.name });
      });
      setTaxs(items.map((item) => ({
        ...item,
        value: item.id,
        label: item.name
      })));
    });
    PartnerService.getList({}).then(({ items }) => {
      const _partners = [];
      items.forEach((item) => {
        _partners.push({ value: item.id, label: item.name });
      });
      setPartners(_partners);
    });
    GroupProductService.getAll().then((items) => {
      const _groupProducts = [];
      items.forEach((item) => {
        _groupProducts.push({ value: item.id, label: item.name });
      });
      setGroupProduct(_groupProducts);
    });
    PaymentTypeService.getAll().then((items) => {
      const _paymentType = [];
      items.forEach((item) => {
        _paymentType.push({ value: item.id, label: item.name });
      });
      setFormData({ ...formData, paymenType: _paymentType[0]?.value })
      setPaymentType(_paymentType);
    });
    CurrencyService.getList({}).then(({ items }) => {
      setCurrency(items);
    })
    TenantSettingService.getList({}).then(({ items, totalCount }) => {
      setTenantSetting(items)
    })
  }, []);

  return (
    <Fragment>
      <Dialog visible={displayPreview} style={{ width: '890px' }} draggable={false} resizable={true} position="top"
        onHide={() => setDisplayPreview(false)} className="view-invoice">
        <iframe className="template-preview" ref={(el) => preview.current = el} title="template-preview" />
      </Dialog>
      <Dialog header={"Đơn hàng"} footer={footer} visible={display} maximized={true} onHide={onHide}
        className="form-xs bg-theme crup-invoice">
        <div className="grid mt-2">
          <div className="col-5 md:col-5 p-1">
            <Fieldset legend="Thông tin chung">
              <div className="p-fluid grid">
                <label className={`col-12 mb-2 md:col-2 md:mb-0`}>Ngày đơn hàng</label>
                <div className={`col-12 md:col-10`} >
                  <Calendar value={formData.orderDate} onChange={(e) => handleFormChange("orderDate", e.value)} dateFormat='dd/mm/yy' showTime showSeconds hourFormat="24" disabled />
                </div>
                <label className={`col-12 mb-2 md:col-2 md:mb-0`}>Số đơn hàng</label>
                <div className={`col-12 md:col-10`} >
                  <InputText value={formData.orderNumber} disabled />
                </div>
                <label className={`col-12 mb-2 md:col-2 md:mb-0`}>HT thanh toán</label>
                <div className={`col-12 md:col-10 `} >
                  <Dropdown value={formData.paymenType} onChange={(e) => { handleFormChange("paymenType", e.value) }} options={paymentType}
                  />
                </div>

              </div>
            </Fieldset>
          </div>
          <div className="col-7 md:col-7 p-1">
            <Fieldset legend="Thông tin bên mua">
              <div className="p-fluid grid">
                <label className={`col-12 mb-2 md:col-2 md:mb-0`}>Mã KH</label>
                <div className={`col-12 md:col-4 p-inputgroup`} >
                  {/* <InputText value={formData.buyerCode} onChange={(e) => handleFormChange("buyerCode", e.target.value)} /> */}
                  <AutoComplete value={formData.buyerCode} suggestions={suggestions} completeMethod={(e) => searchCustomers("code", e)} onChange={(e) => handleFormChange("buyerCode", e.target.value)} />
                  <span className="p-inputgroup-addon" onClick={create}>
                    <i className="pi pi-plus"></i>
                  </span>
                </div>

                <label className={`col-12 mb-2 md:col-2 md:mb-0`}>Tên người mua</label>
                <div className={`col-12 md:col-4`} >
                  <InputText value={formData.buyerDisplayName} onChange={(e) => handleFormChange("buyerDisplayName", e.target.value)} />
                </div>

                <label className={`col-12 mb-2 md:col-2 md:mb-0 `}>CMND/CCCD</label>
                <div className={`col-12 md:col-4 p-inputgroup`} >
                  <AutoComplete value={formData.buyerIdentityCard} suggestions={suggestions} completeMethod={(e) => searchCustomers("identificationCard", e)} onChange={(e) => handleFormChange("buyerIdentityCard", e.target.value)} />
                  <span className="p-inputgroup-addon">
                    <i className="pi pi-search" onClick={() => handleSearchIdentity('createOrder')}></i>
                  </span>
                </div>

                <label className={`col-12 mb-2 md:col-2 md:mb-0`}>Số điện thoại</label>
                <div className={`col-12 md:col-4`} >
                  <InputText value={formData.buyerTel} onChange={(e) => handleFormChange("buyerTel", e.target.value)} />
                </div>

                <label className={`col-12 mb-2 md:col-2 md:mb-0`}>Mã số thuế</label>
                <div className={`col-12 md:col-4 p-inputgroup`} >
                  {/* <InputText value={formData.buyerTaxCode} onChange={(e) => handleFormChange("buyerTaxCode", e.target.value)} /> */}
                  <AutoComplete value={formData.buyerTaxCode} suggestions={suggestions} completeMethod={(e) => searchCustomers('taxCode', e)} onChange={(e) => handleFormChange("buyerTaxCode", e.target.value)} />
                  <span className="p-inputgroup-addon" onClick={() => handleSearchTaxCode("createOrder")}>
                    <i className="pi pi-search" ></i>
                  </span>
                </div>

                <label className={`col-12 mb-2 md:col-2 md:mb-0`}>Tên đơn vị</label>
                <div className={`col-12 md:col-4`} >
                  <InputText value={formData.buyerLegalName} onChange={(e) => handleFormChange("buyerLegalName", e.target.value)} />
                </div>
                <label className={`col-12 mb-2 md:col-2 md:mb-0`}>Địa chỉ</label>
                <div className={`col-12 md:col-4`} >
                  <InputText value={formData.buyerAddress} onChange={(e) => handleFormChange("buyerAddress", e.target.value)} />
                </div>

                <label className={`col-12 mb-2 md:col-2 md:mb-0`}>Email bên mua</label>
                <div className={`col-12 md:col-4`} >
                  <InputText value={formData.buyerEmail} onChange={(e) => handleFormChange("buyerEmail", e.target.value)} />
                </div>

                <label className={`col-12 mb-2 md:col-2 md:mb-0`}>STK bên mua</label>
                <div className={`col-12 md:col-4`} >
                  <InputText value={formData.buyerBankAccount} onChange={(e) => handleFormChange("buyerBankAccount", e.target.value)} />
                </div>



                <label className={`col-12 mb-2 md:col-2 md:mb-0`}>Tại ngân hàng</label>
                <div className={`col-12 md:col-4`} >
                  <InputText value={formData.buyerBankName} onChange={(e) => handleFormChange("buyerBankName", e.target.value)} />
                </div>
              </div>
            </Fieldset>
          </div>
          <div className='col-12 md:col-12 mb-1'>
            <Button icon="pi pi-plus" label="Thêm dòng (F9)" className="p-button-outlined p-button-sm mr-2" onClick={addItem} />
            <Button icon="pi pi-trash" label="Xoá dòng (F8)" className="p-button-outlined p-button-danger p-button-sm mr-2" onClick={deleteItem} />
            <Button icon="pi pi-copy" label="Sao chép (F7)" className="p-button-outlined p-button-success p-button-sm mr-2" onClick={copyItem} />
            <Button icon="pi pi-sign-in" label="Chèn dòng (Ins)" className="p-button-outlined p-button-info p-button-sm mr-2" onClick={insertItem} />
          </div>
          <div className='col-12 md:col-12'>
            {renderDataTable()}

          </div>
          <div className="col-12 p-1">
            <Fieldset legend="Tổng cộng">
              <div className="p-fluid grid">
                <div className='col-12 p-fluid grid'>
                  <label className={`col-1 mb-2 md:mb-0`} >Tổng tiền hàng</label>
                  <div className={`col-1`}>
                    <InputNumber value={formData.amount} onChange={(e) => handleFormChange("amount", e.value)} />
                  </div>

                  <label className={`col-1 mb-2 md:mb-0`}>Tổng tiền phí dịch vụ</label>
                  <div className={`col-1`}>
                    <InputNumber value={formData.serviceCharge} onChange={(e) => handleFormChange("serviceCharge", e.value)} />
                  </div>

                  {
                    tenantSetting.some(item => item.key === "SU_DUNG_THUE_KHAC" && item.value === "C") &&
                    <>
                      <label className={`col-1 mb-2 md:mb-0`}>Tổng tiền thuế khác</label>
                      <div className={`col-1`}>
                        <InputNumber
                          min={0}
                          //max={100}
                          value={formData.ortherTax}
                          onChange={(e) => handleFormChange("ortherTax", e.value)}
                        />
                      </div>
                    </>
                  }

                  <label className={`col-1 mb-2 md:mb-0`}>Tổng tiền trước thuế</label>
                  <div className={`col-1`}>
                    <InputNumber value={formData.totalAmountWithoutVAT} onChange={(e) => handleFormChange("totalAmountWithoutVAT", e.value)} />
                  </div>

                  <label className={`col-1 mb-2 md:mb-0`}>Tổng tiền GTGT</label>
                  <div className={`col-1`}>
                    <InputNumber value={formData.vatAmount} onChange={(e) => handleFormChange("vatAmount", e.value)} />
                  </div>

                  <label className={`col-1 mb-2 md:mb-0`}>Tổng tiền thanh toán</label>
                  <div className={`col-1`}>
                    <InputNumber value={formData.totalAmount} onChange={(e) => handleFormChange("totalAmount", e.value)} />
                  </div>
                </div>
                <div className='col-12 p-fluid grid'>
                  <label className={`col-1 mb-2 md:mb-0`}>Tổng tiền bằng chữ</label>
                  <div className={`col-11`}>
                    <InputText value={formData.totalAmountToWord} onChange={(e) => handleFormChange("totalAmountToWord", e.target.value)} />
                  </div>
                </div>


              </div>
            </Fieldset>
          </div>

        </div>
      </Dialog>
      {renderDialogCrupProduct()}
      {renderDialogTenantClient()}
    </Fragment>
  );
}